import Authentication from '~/components/auth';
import Exit from '~/components/exit';

const EntryPage = () => (
  <Authentication showForgotPassword>
    <Exit />
  </Authentication>
);

export default EntryPage;
